define('modules/page_listing/views/search_tagcloud_item',['require','exports','module','base/itemview','ldsh!../templates/search_tagcloud_item'],function(require, exports, module) {
  "use strict";

  var ItemView = require("base/itemview");

  module.exports = ItemView.extend({
    template: require("ldsh!../templates/search_tagcloud_item"),
    tagName: "div",
    className: "ed-tag",
    triggers: {
      "click .js-remove-tag": "tag:delete"
    }
  });
});

